export default __webpack_public_path__ + "static/media/minimizeIcon.3dcb5d52.svg";